import styles from "./CTASection.module.css";

export default function CTASection() {
  return (
    <section className={styles.cta} id="contato">
      <div className={styles.container}>
        <h2 className={styles.title}>Quer conhecer nossas solucoes?</h2>
        <p className={styles.subtitle}>
          Solicite uma demonstracao gratuita do MBControl ERP ou do
          MBCardapio e veja como podemos transformar a gestao do seu
          negocio.
        </p>

        <div className={styles.buttons}>
          <a
            href="https://wa.me/5517991254844?text=Ol%C3%A1,%20vim%20pelo%20site%20e%20quero%20conhecer%20as%20solucoes%20da%20MB%20Sistemas"
            target="_blank"
            rel="noreferrer"
            className={styles.buttonWhatsapp}
          >
            Chamar no WhatsApp
          </a>
          <a
            href="mailto:contato@mbernardisistemas.com.br?subject=Interesse nas solucoes da MB Sistemas"
            className={styles.buttonEmail}
          >
            Enviar E-mail
          </a>
        </div>

        <p className={styles.note}>
          Sem compromisso. Sem cartao de credito.
        </p>
      </div>
    </section>
  );
}
